import { render, staticRenderFns } from "./epms5060.vue?vue&type=template&id=a60a0310&scoped=true"
import script from "./epms5060.vue?vue&type=script&lang=js"
export * from "./epms5060.vue?vue&type=script&lang=js"
import style0 from "./epms5060.vue?vue&type=style&index=0&id=a60a0310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60a0310",
  null
  
)

export default component.exports